module.exports = __webpack_public_path__ + "img/ofcode.0ea27d2e.png";